<template lang="pug">
.index-overlay(@click="click($event)" :class="modelValue && 'show'" ref="overlay")
  Icon.close(name="x" fill="white" @click="$emit('update:modelValue', false)")
  slot
</template>
<script setup lang="ts">
import { allowScroll, preventScroll } from 'sisu/js/body-scroll'
import { useTemplateRef, watch } from 'vue'

const overlayRef = useTemplateRef<HTMLDivElement>('overlay')

const props = withDefaults(defineProps < {
  modelValue?: boolean,
}>(), {
  modelValue: false,
})

const emit = defineEmits(['update:modelValue'])

watch(() => props.modelValue, (newVal, oldVal) => {
  if (newVal && !oldVal) {
    preventScroll()
  } else if (oldVal && !newVal) {
    allowScroll()
  }
})

function click(e: Event) {
  if (e.target === overlayRef.value) {
    emit('update:modelValue', false)
  }
}
</script>
<style lang="scss" scoped>

.index-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  align-items: center;
  display: flex;
  justify-content: center;
  overscroll-behavior: contain;
  padding: $space-l;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.8);
  transition: opacity 0.2s ease;
  z-index: 100;

  .close {
    position: absolute;
    top: $space-m;
    right: $space-m;
    cursor: pointer;
    width: 24px;
    height: 24px;
    > * {
      pointer-events: none;
    }
  }

  &.show {
    opacity: 1;
    pointer-events: all;
  }

}
</style>
